import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

const LegalLayout = ({ title, children }) => (
  <div className="bg-[#1a1c1b] min-h-screen text-white flex flex-col">
    <Navbar />
    <div className="flex-grow pt-32 pb-20 px-6">
      <div className="container-custom mx-auto max-w-4xl">
        <h1 className="heading-2 mb-8 text-[var(--brand-primary)]">{title}</h1>
        <div className="prose prose-invert max-w-none prose-headings:font-display prose-headings:uppercase prose-a:text-[var(--brand-primary)]">
          {children}
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export const Privacy = () => (
  <LegalLayout title="Privacy Policy">
    <p>Last updated: August 2025</p>
    <h3>1. Introduction</h3>
    <p>Soo Hoo Consulting ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website.</p>
    <h3>2. Data We Collect</h3>
    <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows: Identity Data (name), Contact Data (email, phone), and Technical Data (IP address, browser type).</p>
    <h3>3. How We Use Your Data</h3>
    <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances: Where we need to perform the contract we are about to enter into or have entered into with you.</p>
    <h3>4. Contact Us</h3>
    <p>If you have any questions about this privacy policy, please contact us at: ed@soohoo.com</p>
  </LegalLayout>
);

export const Terms = () => (
  <LegalLayout title="Terms of Service">
    <p>Last updated: August 2025</p>
    <h3>1. Agreement to Terms</h3>
    <p>By accessing our website, you agree to be bound by these Terms of Service and to comply with all applicable laws and regulations.</p>
    <h3>2. Intellectual Property</h3>
    <p>The content, organization, graphics, design, and other matters related to the Site are protected under applicable copyrights and other proprietary laws.</p>
    <h3>3. Services</h3>
    <p>Soo Hoo Consulting provides keynote speaking and consulting services. All services are subject to a separate service agreement.</p>
    <h3>4. Limitation of Liability</h3>
    <p>In no event shall Soo Hoo Consulting be liable for any damages arising out of the use or inability to use the materials on Soo Hoo Consulting's website.</p>
  </LegalLayout>
);

export const Refund = () => (
  <LegalLayout title="Refund Policy">
    <p>Last updated: August 2025</p>
    <h3>1. Speaking Engagements</h3>
    <p>Refunds for speaking engagements are governed by the specific contract signed for the event. generally, deposits are non-refundable to secure the date.</p>
    <h3>2. Consulting Services</h3>
    <p>Consulting services are billed according to the agreed-upon milestones or hourly rates. Disputes regarding services must be raised within 7 days of service delivery.</p>
    <h3>3. Cancellations</h3>
    <p>Cancellations made more than 30 days prior to a scheduled event may be eligible for a partial refund or credit towards a future event, subject to the terms of our service agreement.</p>
    <h3>4. Contact Us</h3>
    <p>If you have any questions about our Returns and Refunds Policy, please contact us: ed@soohoo.com</p>
  </LegalLayout>
);
